import actionCreatorFactory from 'typescript-fsa';

import reduxConfig from '@store/config';
import { User } from '@api/types.generated';
import { UserInput } from '@api/user/user.types';

const actionCreator = actionCreatorFactory(reduxConfig.appName + '/user');

export const createUser = actionCreator.async<UserInput, {}>('USER_CREATE');
export const deleteUser = actionCreator.async<string, {}>('USER_DELETE');
export const updateUser = actionCreator.async<UserInput, User>('USER_UPDATE');
